<template>
  <validation-observer ref="AddForm" #default="{ invalid }">
    <b-form @submit.prevent="formSubmitted">
      <b-row>
        <b-col md="12">
          <b-form-group label="Project Name*" label-for="project-name">
            <validation-provider
              #default="{ errors }"
              name="Project Name"
              vid="Project Name"
              rules="required"
            >
              <b-form-input
                id="project-name"
                placeholder="Project Name"
                required
                v-model="project.name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Description*" label-for="description">
            <validation-provider
              #default="{ errors }"
              name="Description"
              vid="Description"
              rules="required"
            >
              <b-form-textarea
                id="description"
                placeholder="Description"
                rows="3"
                required
                v-model="project.description"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Customer" label-for="customer">
            <b-spinner v-if="loadingCustomer" variant="primary" class="mx-2"></b-spinner>
            <b-form-select
              v-else
              v-model="project.customerId"
              name="customer"
              :options="optionsCustomer"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Assignee*" label-for="assignee">
            <validation-provider
              #default="{ errors }"
              name="Assignee"
              vid="Assignee"
              rules="required"
            >
              <v-select
                id="assignee"
                taggable
                push-tags
                v-model="project.assigneeId"
                dir="ltr"
                multiple
                label="text"
                :options="assignee"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Approver*" label-for="approver">
            <validation-provider
              #default="{ errors }"
              name="Approver"
              vid="Approver"
              rules="required"
            >
              <b-form-select
                id="approver"
                v-model="project.approverId"
                name="approver"
                :options="assignee"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Supervisor" label-for="supervisor">
            <v-select
              id="supervisor"
              taggable
              push-tags
              v-model="project.supervisorId"
              dir="ltr"
              multiple
              label="text"
              :options="assignee"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Budget" label-for="budget">
            <b-form-input id="budget" v-model="project.budget" min="0" type="number" />
          </b-form-group>
        </b-col>

        <!-- <b-col md="12">
          <b-form-group label="Expense" label-for="expense">
            <b-form-input id="expense" v-model="project.expense" min="0" type="number" />
          </b-form-group>
        </b-col> -->

        <b-col md="12">
          <b-form-group label="Duration" label-for="estimates">
            <b-form-input
              id="estimates"
              v-model="project.estimates"
              min="0"
              type="number"
            />
          </b-form-group>
        </b-col>
        <!-- 
        <b-col md="12">
          <b-form-group label="KPITarget1" label-for="kpiTarget1">
            <b-form-input id="kpiTarget1" v-model="project.kpiTarget1" type="number" />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="KPIValue1" label-for="kpiValue1">
            <b-form-input id="kpiValue1" v-model="project.kpiValue1" type="number" />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="KPITarget2" label-for="kpiTarget2">
            <b-form-input id="kpiTarget2" v-model="project.kpiTarget2" type="number" />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="KPIValue2" label-for="kpiValue2">
            <b-form-input id="kpiValue2" v-model="project.kpiValue2" type="number" />
          </b-form-group>
        </b-col> -->

        <!-- submit and reset -->
        <b-col md="12" class="d-flex justify-content-between">
          <b-button type="button" @click="formSubmitted()" variant="primary"
            >Submit</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import {
  fnSortingDropdown,
  customLoader,
  customError,
  customSwal,
} from "@/libs/customFn";

export default {
  name: "AddProject",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BDropdown,
    BDropdownItem,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    assignee: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dir: "ltr",
      selected: [{ title: "Square" }, { title: "Romboid" }],
      assetCode: "",
      name: "",
      selectedAssignee: null,
      description: "",
      purchaseDate: null,
      assignee_options: [],
      lifeEndDate: null,
      maintainanceDate: null,
      location: "",
      selectedCustomer: { id: null, name: "" },
      optionsCustomer: [],
      costPerHour: 0,
      project: {
        name: null,
        description: null,
        customerId: null,
        assigneeId: [],
        supervisorId: [],
        approverId: null,
        approverName: null,
      },
    };
  },

  methods: {
    ...mapActions("customerModule", ["getCustomersListAction"]),
    ...mapActions("projectModule", ["addProjectAction"]),

    async formSubmitted() {
      let isValid = await this.$refs.AddForm.validate();
      if (isValid) {
        let loader = customLoader("Please wait while the project is being added");
        this.project.approverName = this.assignee.filter(
          (x) => x.value === this.project.approverId
        )[0].text;
        this.project.assigneeId = this.project.assigneeId.map((x) => x.value);
        this.project.supervisorId = this.project.supervisorId.map((x) => x.value);
        this.addProjectAction(this.project)
          .then(() => {
            loader.close();
            customSwal("Project has been created");
            this.$emit("projectAdded");
          })
          .catch((ex) => {
            loader.close();
            customError(ex.response.data);
            this.$emit("projectAdded");
          });
      }
    },
  },

  computed: {
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      loadingCustomer: "loading",
    }),
  },

  async mounted() {
    await this.getCustomersListAction().then((res) => {
      this.optionsCustomer = this.CustomerList.map((customer) => ({
        value: customer.id,
      text: `${customer.otherName} ${customer.surname ?? ''}`,
      }));
    });
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
